/**
* Created by lobin on 2020/6/18.
*/
<template>
  <div class="station">
    <a-card :body-style="{padding: '24px'}" :bordered="false" class="cabinet">
      <a-form-model layout="inline" @submit="handleSearch" @submit.native.prevent>
<!--        <a-form-model-item>-->
<!--          <cabinet-grid-tree-select v-model="search" type="input" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item>
          <station-select type="input" v-model="search.stationId" />
        </a-form-model-item>
        <a-form-model-item>
          <a-input v-model="search['cabinet.serial']" placeholder="输入柜子编号"></a-input>
        </a-form-model-item>
        <a-form-item>
          <a-input  v-model="searchForm.mailNo" placeholder="输入单号"/>
        </a-form-item>
<!--        <a-form-model-item>-->
<!--          <a-range-picker-->
<!--              v-model="intimeRange"-->
<!--              format="YYYY-MM-DD"-->
<!--              valueFormat="YYYY-MM-DD"-->
<!--          />-->
<!--        </a-form-model-item>-->
        <a-form-model-item>
          <a-select v-model="searchForm.type" style="width: 100px" placeholder="选择取件类型">
            <a-select-option value="pick">客户取件</a-select-option>
            <a-select-option value="bgo">后台开箱</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-radio-group v-model="searchForm.result" style="width: 140px" placeholder="选择执行结果">
            <a-radio :value="true">成功</a-radio>
            <a-radio :value="false">失败</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item>
          <a-button
              type="primary"
              html-type="submit"
              icon="search"
          >
            查询
          </a-button>
        </a-form-model-item>
      </a-form-model>
      <a-divider />
      <a-table
          :loading="listloading"
          :columns="columns"
          :data-source="list"
          :scroll="{ x: 1800, y: 500 }"
          :pagination="pager"
          @change="change">
        <span slot="action" slot-scope="text, record">
          <a @click="showdetail(record)">详情</a>
        </span>
        <span slot="sendResult" slot-scope="text, record">
          <a-tag color="#87d068" v-if="record.sendResult">成功</a-tag>
          <a-tooltip placement="top" v-else>
            <template slot="title">
              <span>{{ record.sendError }}</span>
            </template>
            <a-tag color="#f50">失败</a-tag>
          </a-tooltip>
        </span>
        <span slot="result" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ record.responseText }}</span>
            </template>
            <a-tag color="green" v-if="record.result">成功</a-tag>
            <a-tag color="red" v-else>失败</a-tag>
          </a-tooltip>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script type="text/babel">
import { cabinetlog } from '@/api/cabinet';

const columns = [
  {
    title: '#',
    dataIndex: 'index',
    customRender: (text, row, index) => index + 1,
    key: 'index',
    width: '50px',
  },
  {
    title: '站点名称',
    dataIndex: 'station.name',
    key: 'stationName',
  },
  {
    title: '发送结果',
    dataIndex: 'sendResult',
    key: 'sendResult',
    scopedSlots: { customRender: 'sendResult' },
  },
  {
    title: '执行结果',
    dataIndex: 'result',
    key: 'result',
    scopedSlots: { customRender: 'result' },
  },
  {
    title: '格子编号',
    dataIndex: 'cabinet.serial',
    key: 'cabinetserial',
  },
  {
    title: '主板号',
    dataIndex: 'cabNum',
    key: 'cabNum',
  },
  {
    title: '通道',
    dataIndex: 'cabinet.channel',
    key: 'cabinetchannel',
    customRender: (text, row) => `CH${row.cabinet.channel.toString().length === 1 ? (`0${row.cabinet.channel}`) : row.cabinet.channel}`,
  },
  {
    title: '单号',
    dataIndex: 'mailNo',
    key: 'mailNo',
  },
  {
    title: '命令',
    dataIndex: 'commandTxt',
    width: '150px',
    key: 'commandTxt',
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '发送时间',
    dataIndex: 'ctime',
    key: 'ctime',
  },
  {
    title: '返回时间',
    dataIndex: 'resTime',
    key: 'resTime',
  },
  {
    title: '差(ms)',
    dataIndex: 'difTime',
    key: 'difTime',
  },
  {
    title: '操作人',
    dataIndex: 'user.name',
    key: 'username',
    width: '120px',
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 80,
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  data() {
    return {
      searchForm: {
        page: 1,
      },
      search: {},
      listloading: false,
      list: [],
      columns,
      pager: {
        pageSize: 20,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.listloading = true;
      try {
        const { data: { docs, pager } } = await cabinetlog({
          ...this.searchForm,
          ...this.search,
        });
        this.list = docs;
        this.pager = {
          ...pager,
          showTotal: (total) => `共计 ${total} 条信息`,
        };
      } catch (e) {
        this.$message.error(e);
      }
      this.listloading = false;
    },
    change(pagination) {
      this.searchForm.page = pagination.current;
      this.getList();
    },
    handleSearch() {
      this.getList();
    },
    showdetail() {
      this.$message.info('开发中');
    },
  },
};

</script>

<style lang="less" rel="stylesheet/less">
.station {
}
</style>
